import { render, staticRenderFns } from "./BackgroundParticles.vue?vue&type=template&id=db0125d2&lang=pug&"
import script from "./BackgroundParticles.vue?vue&type=script&lang=js&"
export * from "./BackgroundParticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports